export const MenuData=[
    {
        id:700,
        isGroup:true,
        caption:'Закупівлі',
        visibility:'constStandard',
        icon:'b101',
        wndType:'grpSupply',
        data:[
            {
                id:103,
                isGroup:false,
                caption:'Контрагенти',
                icon:'b103',
                multytab:false,
                wndType:'catCounterparties_list'
            },
            {
                id:104,
                isGroup:false,
                caption:'Поступлення',
                icon:'b220',
                multytab:false,
                wndType:'docSupply_list'
            },
            {
                id:105,
                isGroup:false,
                caption:'Повернення',
                icon:'b220',
                multytab:false,
                wndType:'docReject_list'
            },
            {
                id:113,
                isGroup:false,
                caption:'Звіт з поступлень',
                icon:'b230',
                multytab:true,
                wndType:'repSupplies'
            },
            {
                id:719,
                isGroup:false,
                caption:'Звіт по заборгованості',
                icon:'b230',
                multytab:true,
                wndType:'repLiability'
            },
        ]
    },
            
    {
        id:100,
        isGroup:true,
        caption:'Склад',
        icon:'b104',
        wndType:'grpStock',
        data:[
            {
                id:101,
                isGroup:false,
                caption:'Товари',
                icon:'b100',
                multytab:false,
                wndType:'catGoods_list'
            },
            {
                id:102,
                isGroup:false,
                caption:'Підрозділи',
                icon:'b102',
                multytab:false,
                wndType:'catDepartments_list'
            },

            {
                id:106,
                isGroup:false,
                caption:'Переміщення',
                visibility:'constStandard',
                icon:'b220',
                multytab:false,
                wndType:'docTransfer_list'
            },
            {
                id:107,
                isGroup:false,
                caption:'Списання',
                icon:'b220',
                multytab:false,
                wndType:'docExpence_list'
            },
            {
                id:108,
                isGroup:false,
                caption:'Оприбуткування',
                icon:'b220',
                multytab:false,
                wndType:'docSurplus_list'
            },
            {
                id:110,
                isGroup:false,
                caption:'Інвентаризація',
                visibility:'constStandard',
                icon:'b220',
                multytab:false,
                wndType:'docRevision_list'
            },
            {
                id:112,
                isGroup:false,
                caption:'Звіт про залишки',
                icon:'b230',
                multytab:true,
                wndType:'repStock'
            },
            {
                id:113,
                isGroup:false,
                caption:'Форма обліку товарних запасів',
                visibility:'constStandard',
                icon:'b230',
                multytab:true,
                wndType:'repForm496'
            }
        ]
    },

    {
        id:600,
        isGroup:true,
        caption:'Виробництво',
        icon:'b300',
        wndType:'grpProd',
        data:[
            {
                id:108,
                isGroup:false,
                caption:'Стоп-лист',
                icon:'b958',
                multytab:false,
                wndType:'irgStopList'
            },
            {
                id:109,
                isGroup:false,
                caption:'Випуск',
                icon:'b220',
                multytab:false,
                wndType:'docProduction_list'
            },
            {
                id:110,
                isGroup:false,
                caption:'Переробка',
                icon:'b220',
                multytab:false,
                wndType:'docConversion_list'
            }, 
            {
                id:111,
                isGroup:false,
                caption:'Калькуляції',
                icon:'b220',
                multytab:false,
                wndType:'docCalculation_list'
            },
            {
                id:114,
                isGroup:false,
                caption:'Звіт по калькуляціях',
                icon:'b230',
                multytab:true,
                wndType:'repCalcs'
            },
            {
                id:285,
                isGroup:false,
                caption:'Звіт по виробництву',
                icon:'b230',
                multytab:true,
                wndType:'repProduction'
            },
            {
                id:284,
                isGroup:false,
                caption:'Звіт по переробках',
                icon:'b230',
                multytab:true,
                wndType:'repConversion'
            },
        ]
    },


    {
        id:200,
        isGroup:true,
        caption:'Продажі',
        icon:'b200',
        wndType:'grpSales',
        data:[
            {
                id:201,
                isGroup:false,
                caption:'Категорії меню',
                icon:'b201',
                multytab:false,
                wndType:'catMenuGrp_list'
            },
            {
                id:203,
                isGroup:false,
                caption:'Клієнти/Знижки',
                icon:'b203',
                multytab:false,
                wndType:'catDiscounts_list'
            },
            {
                id:250,
                isGroup:true,
                caption:'Сертифікати',
                icon:'b251',
                visibility:'constCertPay',
                wndType:'grpCerts',
                data:[
                    {
                        id:251,
                        isGroup:false,
                        caption:'Список сертифікатів',
                        icon:'b250',
                        multytab:false,
                        wndType:'catCertificates_list'
                    },
                    {
                        id:252,
                        isGroup:false,
                        caption:'Журнал поповнень',
                        icon:'b220',
                        multytab:false,
                        wndType:'docRefillCert_list'
                    },
                    {
                        id:253,
                        isGroup:false,
                        caption:'Журнал списань',
                        icon:'b220',
                        multytab:false,
                        wndType:'docNullifyCert_list'
                    },
                ]
            },
            {
                id:220,
                isGroup:false,
                caption:'Журнал продаж',
                icon:'b220',
                multytab:false,
                wndType:'docOrder_list'
            },
            {
                id:230,
                isGroup:false,
                caption:'Звіт з продаж',
                icon:'b230',
                multytab:true,
                wndType:'repSales'
            },
            {
                id:240,
                isGroup:false,
                caption:'Звіт по відмовах',
                icon:'b230',
                multytab:true,
                wndType:'repReturn'
            },
            {
                id:260,
                isGroup:false,
                caption:'Звіт по боржниках',
                icon:'b230',
                multytab:false,
                wndType:'repDebt'
            },
            {
                id:270,
                isGroup:false,
                caption:'Статистика роботи',
                icon:'b230',
                multytab:false,
                wndType:'repStats'
            },
        ]
    },
    {
            id:280,
            isGroup:true,
            caption:'Доставка',
            visibility:'constXprs',
            icon:'b700',
            wndType:'grpDLV',
            data:[
            {
                id:281,
                isGroup:false,
                caption:'Населені пункти',
                icon:'b281',
                multytab:false,
                wndType:'catCities_list'
            },
            {
                id:282,
                isGroup:false,
                caption:'Райони',
                icon:'b282',
                multytab:false,
                wndType:'catAreas_list'
            },
            {
                id:225,
                isGroup:false,
                caption:'Адреси доставки',
                icon:'b225',
                multytab:false,
                wndType:'catStreets_list'
            },
            {
                id:283,
                isGroup:false,
                caption:'Тарифи',
                icon:'b284',
                multytab:false,
                wndType:'catStreets_list'
            },
            {
                id:284,
                isGroup:false,
                caption:'Звіт по доставках',
                icon:'b230',
                multytab:true,
                wndType:'repDelivery'
            },
            /*{
                id:284,
                isGroup:false,
                caption:'Налаштування знижок',
                icon:'b284',
                multytab:false,
                wndType:'catStreets_list'
            },*/
        ]
    },

    {
        id:300,
        isGroup:true,
        caption:'Персонал',
        icon:'b600',
        wndType:'grpHR',
        data:[
            {
                id:301,
                isGroup:false,
                caption:'Працівники',
                icon:'b601',
                multytab:false,
                wndType:'catEmployees_list'
            },
            {
                id:302,
                isGroup:false,
                caption:'Посади',
                icon:'b602',
                multytab:false,
                wndType:'catPositions_list'
            },
            {
                id:303,
                isGroup:false,
                caption:'Табелі',
                icon:'b603',
                multytab:false,
                wndType:'irgTimekeeping_list'
            },
            {
                id:304,
                isGroup:false,
                caption:'Зарплата',
                icon:'b220',
                multytab:false,
                wndType:'docSalary_list'
            },
            {
                id:305,
                isGroup:false,
                caption:'Виплати з/п',
                icon:'b220',
                multytab:false,
                wndType:'docPayment_list'
            }
        ]
    },
    {
        id:400,
        isGroup:true,
        caption:'Фінанси',
        visibility:'constStandard',
        icon:'b400',
        wndType:'grpFinance',
        data:[
            { //КОШТИ
                id:401,
                isGroup:false,
                caption:'Статті руху',
                icon:'b402',
                multytab:false,
                wndType:'catArticles_list'
            },
            {
                id:402,
                isGroup:false,
                caption:'Каси/Рахунки',
                icon:'b401',
                multytab:false,
                wndType:'catCashAccs_list'
            },
            {
                id:404,
                isGroup:false,
                caption:'Касова виписка',
                icon:'b220',
                multytab:false,
                wndType:'docStatement_list'
            }, //Звіт про рух коштів
            {
                id:405,
                isGroup:false,
                caption:'Звіт про рух коштів',
                icon:'b230',
                multytab:false,
                wndType:'repCashflow'
            }, 
            {
                id:409,
                isGroup:false,
                caption:'Прибутки та збитки',
                icon:'b230',
                multytab:false,
                wndType:'repPnL'
            }, 
            {
                id:406,
                isGroup:false,
                caption:'Коригування боргів',
                icon:'b220',
                multytab:false,
                wndType:'docDebtadjust_list'
            },
            {
                id:407,
                isGroup:false,
                caption:'Коригування коштів',
                icon:'b220',
                multytab:false,
                wndType:'docCashadjust_list'
            },
            {
                id:408,
                isGroup:false,
                caption:'Коригування бонусів',
                icon:'b220',
                multytab:false,
                wndType:'docBonusadjust_list'
            }
        ]
    },
    {
        id:500,
        isGroup:true,
        caption:'Адміністрування',
        icon:'b500',
        wndType:'grpAdmin',
        data:[
            {
                id:501,
                isGroup:false,
                caption:'Користувачі',
                icon:'b501',
                multytab:false,
                wndType:'catUsers_list'
            },
            {
                id:502,
                isGroup:false,
                caption:'Зали',
                icon:'b502',
                multytab:false,
                wndType:'catHalls_list'
            },
            {
                id:503,
                isGroup:false,
                caption:'Обладнання',
                icon:'b503',
                multytab:false,
                wndType:'catDevices_list'
            },
            {
                id:505,
                isGroup:false,
                caption:'Шаблони відмов',
                icon:'b506',
                multytab:false,
                visibility:'constTurnTmpl',
                wndType:'catReasons_list'
            },
            {
                id:507,
                isGroup:false,
                caption:'Шаблони коментарів',
                icon:'b402',
                multytab:false,
                wndType:'catTexts_list'
            },
            {
                id:508,
                isGroup:false,
                caption:'QR коди',
                icon:'b957',
                multytab:false,
                wndType:'servQRDesign'
            },
            {
                id:506,
                isGroup:false,
                caption:'Історія дій',
                icon:'b505',
                multytab:false,
                wndType:'repSysLog'
            },
            {
                id:509,
                isGroup:false,
                caption:'Експорт даних',
                icon:'xlsx',
                multytab:false,
                wndType:'repSysBASE'
            },
            {
                id:504,
                isGroup:false,
                caption:'Налаштування',
                icon:'b504',
                multytab:false,
                wndType:'sysConst_list'
            }
        ]
    },
                /*{
                    id:800,
                    isGroup:true,
                    caption:'Сервіс',
                    icon:'b504',
                    data:[
                        {
                            id:801,
                            isGroup:false,
                            caption:'Історія дій',
                            icon:'b504',
                            multytab:false,
                            wndType:'repSysLog'
                        },/*
                        {
                            id:702,
                            isGroup:false,
                            caption:'Коригування каси',
                            icon:'b220',
                            multytab:false,
                            wndType:'docCorCahs_list'
                        },
                        {
                            id:503,
                            isGroup:false,
                            caption:'Коригування боргів',
                            icon:'b220',
                            multytab:false,
                            wndType:'docCorLoan_list'
                        },
                        {
                            id:504,
                            isGroup:false,
                            caption:'Налаштування',
                            icon:'b504',
                            multytab:false,
                            wndType:'sysConst_list'
                        }
                    ]
                },*/
            ]